
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { UFliterals } from "@/utils/literals";
import { ISequence } from "@/schemas/ISequence";
import { ISetting } from "@/schemas/ISetting";
import { validationMixin } from "vuelidate";
import {
  between,
  integer,
  maxLength,
  minLength,
  minValue,
  required,
} from "vuelidate/lib/validators";
import { IActivity } from "@/schemas/IActivity";
import { ITipGroup } from "@/schemas/ITipGroup";
import { IInstructor, IUser } from "@/schemas/IUser";
import { AttendanceType, FeedbackType, Scope, UnitType } from "@/schemas/Enums";
import { UFFormValidationMessage } from "@/utils/literals/forms";
import FeedbackSettingForm from "@/components/admin/entityForm/FeedbackSettingForm.vue";
import { infoTooltips } from "@/utils/literals/admin";
import { mapGetters } from "vuex";

@Component({
  name: "SequenceForm",
  components: { FeedbackSettingForm },
  computed: {
    UnitType() {
      return UnitType;
    },
    FeedbackType() {
      return FeedbackType;
    },
    ...mapGetters("user", ["isAdministrator"]),
  },
  mixins: [validationMixin],
  validations: {
    sequence: {
      title: {
        required,
        maxLength: maxLength(100),
        minLength: minLength(5),
      },
      description: {
        required,
        maxLength: maxLength(1000),
        minLength: minLength(10),
      },
      authorized_instructors: {},
      settings: {
        minLength: minLength(1),
        $each: {
          first_feedback: {},
          second_feedback: {},
          attendance_type: { required },
          single_session_time: {
            integer,
            maxLength: maxLength(3),
            minLength: minLength(1),
            required,
            between: between(1, 999),
          },
          activity_id: { required },
          indiv_tips_id: {},
          group_tips_id: {},
          overview_tips_id: {},
          group_session_time: {
            integer,
            maxLength: maxLength(3),
            minLength: minLength(1),
            required,
            between: between(1, 999),
            minValue: minValue(1),
          },
          text_only: {},
          tip_groups: {},
          feedback: {},
          feedback_details: {
            $each: {
              type: {},
              display_score: {},
              display_feedback_message: {},
            },
          },
          tip_overview: {
            requiredIf: (
              value,
              { indiv_tips_id, group_tips_id, overview_tips_id }
            ) => {
              if (value) {
                return !!(indiv_tips_id || group_tips_id || overview_tips_id);
              }
              return true; // Pas d'obligation si le switch est désactivé
            },
          },
          carousel_tips: {},
          carousel_tip_unit: {},
          display_username_copy: {},
          display_video: {},
          carousel_display_time: { integer },
          carousel_occurrence: { integer },
        },
      },
    },
  },
})
export default class SequenceForm extends Vue {
  @Prop({ type: String, required: false, default: UFliterals.create })
  readonly submitText: string | undefined;
  @Prop({ type: Function, required: false })
  readonly dataHandler: CallableFunction | undefined;
  @Prop({ type: Boolean, required: false, default: false })
  readonly readOnly: boolean | undefined;
  @Prop({ type: Object, required: false })
  readonly initialSequence: ISequence | undefined;

  dialogCancel = false;
  sequence: ISequence = { title: "", description: "", is_open: false };
  activities: IActivity[] = [];
  activityOpened = false;
  tipGroups: ITipGroup[] = [];
  instructors: IInstructor[] = [];
  author = [];
  displayParticipationSettings: { [index: number]: boolean } = {};
  displayPerformanceSettings: { [index: number]: boolean } = {};
  lang = "fr";

  data(): any {
    return {
      dialogClose: false,
      dialogClose2: false,
      dialog: "",
      creation: true,
      fullyLoaded: false,
      authorArray: [],
      // userList: [],
    };
  }

  finished_activity_filter(tab): any {
    var filtered = [];
    var key = Object.keys(tab);
    key.forEach((l) => {
      if (tab[l].$model.opened_at !== null) {
        filtered.push(tab[l]);
      }
    });

    return filtered;
  }

  scheduled_activity_filter(tab): any {
    var filtered = [];
    var key = Object.keys(tab);
    key.forEach((l) => {
      if (tab[l].$model.opened_at == null) {
        filtered.push(tab[l]);
      }
    });
    return filtered;
  }

  chronoSort(tab): any {
    var filtered = [];
    var finished = [];
    var key = Object.keys(tab);
    key.forEach((l) => {
      if (tab[l].$model.opened_at == null) {
        filtered.push(tab[l]);
      } else {
        finished.push(tab[l]);
      }
    });

    return filtered.concat(finished);
  }

  chronoSort2(tab): any {
    var filtered = [];
    var finished = [];
    var key = Object.keys(tab);
    key.forEach((l) => {
      if (tab[l].opened_at == null) {
        filtered.push(tab[l]);
      } else {
        finished.push(tab[l]);
      }
    });

    return filtered.concat(finished);
  }

  created(): void {
    console.log(this.isAdministrator);
    console.log("----");
    this.fetchRequiredData();
    this.activityOpened = false;
    this.creation = true;
    if (this.initialSequence) {
      if (Object.keys(this.initialSequence).length) {
        this.sequence = { ...this.initialSequence };
        this.creation = false;
      }
    }
    if (this.sequence) {
      if (this.sequence.is_open == true) {
        this.activityOpened = true;
      }
    }
  }

  private fetchRequiredData() {
    if (!this.author.length) {
      this.$store.dispatch("user/fetchPoweredUsers2", (authors: IUser[]) => {
        this.authorArray = authors.reduce(
          (acc: Record<number, string>, author: IUser) => {
            acc[author.id] = author.username;
            return acc;
          },
          {}
        );
      });
    }
    this.$store.dispatch(
      "user/fetchInstructors",
      (instructors: IInstructor[]) => (this.instructors = instructors)
    );
    if (!this.activities.length) {
      this.$store.dispatch("activity/fetchActivities", {
        next: (activities: IActivity[]) => (this.activities = activities),
      });
    }
    if (!this.tipGroups.length) {
      this.$store.dispatch("tipGroup/fetchTipGroups", {
        next: (tipGroups: ITipGroup[]) => (this.tipGroups = tipGroups),
      });
    }
    this.fullyLoaded = true;
  }

  @Watch("initialSequence")
  initialActivityChanged(val: ISequence): void {
    if (Object.keys(this.initialSequence).length) {
      this.creation = false;
    } else {
      this.creation = true;
    }
    this.renewSequence(val);
  }

  get groupTipsSelectValues(): { value: string; text: string }[] {
    let selectValues: { value: string; text: string }[] = [];
    this.tipGroups?.forEach((tipGroup) => {
      if (tipGroup.id && tipGroup.scope === Scope.Group) {
        selectValues.push({ value: tipGroup.id, text: tipGroup.title });
      }
    });
    return selectValues;
  }

  get indivTipsSelectValues(): { value: string; text: string }[] {
    let selectValues: { value: string; text: string }[] = [];
    this.tipGroups?.forEach((tipGroup) => {
      if (tipGroup.id && tipGroup.scope === Scope.Individual) {
        selectValues.push({ value: tipGroup.id, text: tipGroup.title });
      }
    });
    return selectValues;
  }

  get addSettingButtonText(): string {
    return this.sequence.settings?.length
      ? this.getUFLabel("addOtherActivity")
      : this.getUFLabel("addActivity");
  }
  formatActivityText(text: string): string {
    const tab = text.split("|");
    const newT = `<b>${tab[0]}</b>`;
    tab[0] = newT;
    return tab.join("|");
  }

  get activitiesSelectValues(): { value: string; text: string }[] {
    let selectValues: { value: string; text: string }[] = [];
    this.activities?.forEach((activity) => {
      if (activity.id) {
        let authorName = this.authorArray[activity.author_id];
        let validation = activity.is_validated;
        if (validation == null || validation == false) {
          validation = "Non validée";
        } else {
          validation = "Validée";
        }
        let text = "";
        if (authorName) {
          text = `${activity.title} | ${validation} | ${this.getUFLabel(
            activity.discipline
          )} | ${authorName}`;
        } else {
          text = `${activity.title} | ${validation} | ${this.getUFLabel(
            activity.discipline
          )}`;
        }

        selectValues.push({ value: activity.id, text: text });
      }
    });
    console.log(selectValues);
    return selectValues;
  }

  get attendanceSelectValues(): { value: string; text: string }[] {
    let selectValues: { value: string; text: string }[] = [];
    Object.values(AttendanceType).forEach((attendanceType) => {
      selectValues.push({
        value: attendanceType,
        text: this.getUFLabel(attendanceType),
      });
    });
    return selectValues;
  }

  get titleErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.title?.$dirty) return errors;
    !this.$v.sequence.title.minLength &&
      errors.push(UFFormValidationMessage.minLengthChar(5));
    !this.$v.sequence.title.maxLength &&
      errors.push(UFFormValidationMessage.maxLengthChar(100));
    !this.$v.sequence.title.required &&
      errors.push(UFFormValidationMessage.required);
    return errors;
  }

  getSingleSessionTimeErrors(index: number): string[] {
    const errors: string[] = [];
    if (
      !this.$v.sequence.settings?.$each.$iter[index]?.single_session_time
        ?.$dirty
    )
      return errors;
    !this.$v.sequence.settings?.$each.$iter[index]?.single_session_time
      .minLength && errors.push(UFFormValidationMessage.minLengthNum(1));
    !this.$v.sequence.settings?.$each.$iter[index]?.single_session_time
      .maxLength && errors.push(UFFormValidationMessage.maxLengthNum(3));
    !this.$v.sequence.settings?.$each.$iter[index]?.single_session_time
      .required && errors.push(UFFormValidationMessage.required);
    !this.$v.sequence.settings?.$each.$iter[index]?.single_session_time
      .between && errors.push(UFFormValidationMessage.between(1, 999));
    return errors;
  }

  getAttendanceTypeErrors(index: number): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.settings?.$each.$iter[index]?.attendance_type?.$dirty)
      return errors;
    !this.$v.sequence.settings?.$each.$iter[index]?.attendance_type.required &&
      errors.push(UFFormValidationMessage.required);
    return errors;
  }

  getActivityIdErrors(index: number): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.settings?.$each.$iter[index]?.activity_id?.$dirty)
      return errors;
    !this.$v.sequence.settings?.$each.$iter[index]?.activity_id.required &&
      errors.push(UFFormValidationMessage.required);
    return errors;
  }

  getGroupTipsErrors(index: number): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.settings?.$each.$iter[index]?.group_tips_id?.$dirty)
      return errors;
    return errors;
  }

  getIndivTipsErrors(index: number): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.settings?.$each.$iter[index]?.indiv_tips_id?.$dirty)
      return errors;
    return errors;
  }

  getTipsErrors(index: number): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.settings?.$each.$iter[index]?.tip_overview?.$dirty)
      return errors;
    !this.$v.sequence.settings?.$each.$iter[index]?.tip_overview.requiredIf &&
      errors.push(UFFormValidationMessage.atLeast1);
    return errors;
  }

  getGroupSessionTimeErrors(index: number): string[] {
    const errors: string[] = [];
    if (
      !this.$v.sequence.settings?.$each.$iter[index]?.group_session_time?.$dirty
    )
      return errors;
    !this.$v.sequence.settings?.$each.$iter[index]?.group_session_time
      .minLength && errors.push(UFFormValidationMessage.minLengthNum(1));
    !this.$v.sequence.settings?.$each.$iter[index]?.group_session_time
      .maxLength && errors.push(UFFormValidationMessage.maxLengthNum(3));
    !this.$v.sequence.settings?.$each.$iter[index]?.group_session_time
      .required && errors.push(UFFormValidationMessage.required);
    !this.$v.sequence.settings?.$each.$iter[index]?.group_session_time
      .between && errors.push(UFFormValidationMessage.between(1, 999));
    return errors;
  }

  get descriptionErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.sequence.description?.$dirty) return errors;
    !this.$v.sequence.description.minLength &&
      errors.push(UFFormValidationMessage.minLengthChar(10));
    !this.$v.sequence.description.maxLength &&
      errors.push(UFFormValidationMessage.maxLengthChar(1000));
    !this.$v.sequence.description.required &&
      errors.push(UFFormValidationMessage.required);
    return errors;
  }

  get instructorSelectOptions(): Record<string, string>[] {
    return this.instructors.map((instructor) => {
      return {
        text: instructor.username,
        value: instructor.id,
      };
    });
  }

  renewSequence(value: ISequence): void {
    this.sequence = Object.assign({}, value);
  }

  getUFLabel(key: string): string {
    return UFliterals[key];
  }

  getSettingNumber(index: number): number {
    return ++index;
  }

  addSetting(): void {
    let newSetting: ISetting = {
      activity_id: "",

      attendance_type: AttendanceType.Physical,
      single_session_time: 10,
      group_session_time: 30,
      text_only: true,
      tip_overview: true,
      feedback: true,
      display_username_copy: false,
      display_video: true,
      indiv_tips_id: "",
      group_tips_id:
        this.groupTipsSelectValues.find(
          (t) => t.value === "0a14ea7d-0ee9-4f30-a552-7c5bac573c71"
        )?.value ||
        this.groupTipsSelectValues[0]?.value ||
        "",
      overview_tips_id:
        this.groupTipsSelectValues.find(
          (t) => t.value === "0a14ea7d-0ee9-4f30-a552-7c5bac573c71"
        )?.value ||
        this.groupTipsSelectValues[0]?.value ||
        "",
      feedback_details: [
        {
          type: FeedbackType.Performance,
          display_feedback_message: true,
          display_avg_feedback: true,
        },
        { type: FeedbackType.Participation, display_feedback_message: true },
      ],
      carousel_tips: false,
      carousel_tip_unit: UnitType.DisplayTime,
    };
    if (!this.sequence.settings) {
      Vue.set(this.sequence, "settings", [newSetting]);
    } else {
      Vue.set(
        this.sequence.settings,
        this.sequence.settings?.length,
        newSetting
      );
    }
  }

  removeSettingConfirmation(index): void {
    // if( this.suppressionAlert== false){
    //   alert({
    //     title: "Avertissement",
    //     message: "La suppression d'une activité est irréversible.",
    //     okButtonText: "J'ai compris."
    //   }).then(() => {
    //     console.log("Alert dialog closed");
    //   });
    // }
    // else{
    //   this.removeSetting(index)
    // }
  }

  removeSetting(index: number): void {
    if (this.sequence.settings) {
      let orderedArray = this.chronoSort2(this.sequence.settings);
      this.sequence.settings = this.chronoSort2(this.sequence.settings);
      let elementToRemove = orderedArray[index];
      if (elementToRemove) {
        if (elementToRemove.id) {
          // The element is already saved, so we'll have to remove it
          this.$store.dispatch("setting/deleteSetting", {
            id: elementToRemove.id,
            next: () => {
              this.sequence.settings.splice(index, 1);
            },
          });
          this.sequence.settings.splice(index, 1);
        } else {
          this.sequence.settings.splice(index, 1);
        }
      }
      this.dialog = false;
    }
  }

  clearOverviewTipId(index: number): void {
    if (this.sequence.settings) {
      Vue.set(this.sequence.settings[index], "overview_tips_id", "");
    }
  }

  handleSubmit(): void {
    this.$v.$touch();
    this.$nextTick(() => {
      this.scrollToFirstInvalidControl();
    });

    if (!this.$v.$invalid) {
      if (this.dataHandler) {
        this.dataHandler(this.sequence);
      }
    }
  }

  clear(): void {
    this.$v.$reset();
    this.sequence = { title: "", description: "", is_open: false };
  }

  onActivityChange(activityId: string, settingIndex: number): void {
    let selectedActivity = this.activities.find(
      (activity) => activity.id === activityId
    );
    if (this.sequence.settings) {
      if (this.sequence.settings[settingIndex]) {
        Vue.set(
          this.sequence.settings[settingIndex],
          "single_session_time",
          selectedActivity?.single_session_time
        );
        Vue.set(
          this.sequence.settings[settingIndex],
          "group_session_time",
          selectedActivity?.group_session_time
        );
      }
    }
  }

  scrollToFirstInvalidControl(): void {
    const firstInvalidControl: HTMLElement =
      document.getElementsByClassName("error--text");
    // FIXME
    console.log(firstInvalidControl);
    // firstInvalidControl[0].focus(); //without smooth behavior
  }

  getTooltipContent(key: string): string {
    return infoTooltips[this.lang][key];
  }
}
